import {useDispatch, useSelector} from "react-redux";
import {getSelectedUserColumns, getTotalColumns, UserListActions} from "./model";
import {useOktaAuth} from "@okta/okta-react";
import {useEffect} from "react";
import {isNullOrUndefined} from "../../../common/utils";

export const UserListController = (page, size, userQuery, sorter) => {
  const { authState } = useOktaAuth();
  const dispatch = useDispatch();

  const {
    value: { data, totalPages, totalElements, canViewAllUsers },
    progress,
  } = useSelector((rootState) => rootState.userList.userList);

  let selectedColumns = useSelector((rootState) => getSelectedUserColumns(rootState.userList));
  let columns = useSelector((rootState) => rootState.userList.columns);

  useEffect(() => {
    if (authState.isAuthenticated) {
      dispatch(
        UserListActions.getUserList({
          page: page,
          size: size,
          userQuery: userQuery,
          sorter: sorter,
        }),
      );
    }
  }, [dispatch, authState, page, size, JSON.stringify(userQuery), JSON.stringify(sorter)]);

  useEffect(() => {
    if (!isNullOrUndefined(columns)) {
      const totalColumns = columns.map(({ title }) => title);
      selectedColumns = selectedColumns.length > 0 ? selectedColumns : totalColumns;
      dispatch(UserListActions.setActiveColumns({ totalColumns, selectedColumns }));
    }
  }, [columns]);

  const totalColumns = useSelector((rootState) => getTotalColumns(rootState.userList));

  const setSelectedColumns = (selectedColumns) => {
    dispatch(UserListActions.setActiveColumns({ selectedColumns }));
  };

  return {
    data,
    columns,
    totalPages,
    totalElements,
    canViewAllUsers,
    isLoading: !!progress,
    selectedColumns,
    totalColumns,
    setSelectedColumns,
  };
};
